// @core/api/endpoints/chat/add_conversation_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddConversationMemberRequest,
  ConversationMemberResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Add member to conversation
 * Adds a new member to a group conversation with the specified role. The new member will have access to the full message history.
 */
export async function AddConversationMember(
  conversation_id: string,
  data: AddConversationMemberRequest,
  options?: RequestOptions
): Promise<ConversationMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/members`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.post<ConversationMemberResponse>(requestPath, data, requestOptions);
}
